<script setup>

import DayPart from "./DayPart.vue";
import Button from "primevue/button";
import {computed, ref, watch} from "vue";
import { trans } from 'laravel-vue-i18n';


const days = ref([
    { day: trans('common.dow_short.mon'), identifier: 'mon', slots: [] },
    { day: trans('common.dow_short.tue'), identifier: 'tue', slots: [] },
    { day: trans('common.dow_short.wed'), identifier: 'wed', slots: [] },
    { day: trans('common.dow_short.thu'), identifier: 'thu', slots: [] },
    { day: trans('common.dow_short.fri'), identifier: 'fri', slots: [] },
    { day: trans('common.dow_short.sat'), identifier: 'sat', slots: [] },
    { day: trans('common.dow_short.sun'), identifier: 'sun', slots: [] },
]);

const minTime = ref(6);
const maxTime = ref(18);
const increment = ref(0.5);
const slotHeight = ref(42);
const activeEvent = ref(null);
const model = defineModel();
const form = defineModel('form');

const times = computed(() => {
    let slots = [];
    for (let time = minTime.value; time <= maxTime.value; time += increment.value) {
        slots.push(time);
    }
    return slots;
})

const numberToTime = (num) => {
    const hours = Math.floor(num)
    const minutes = (num - hours) * 60
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}

const activeDay = ref('mon');

const computedDay = computed(() => days.value.find(el => el.identifier === activeDay.value));

const dayIdentifiers = days.value.map(d => d.identifier);

const prevDay = () => {
  const currentIndex = dayIdentifiers.indexOf(activeDay.value);
  const prevIndex = (currentIndex - 1 + dayIdentifiers.length) % dayIdentifiers.length;
  activeDay.value = dayIdentifiers[prevIndex];
}

const nextDay = () => {
  const currentIndex = dayIdentifiers.indexOf(activeDay.value);
  const nextIndex = (currentIndex + 1) % dayIdentifiers.length;
  activeDay.value = dayIdentifiers[nextIndex];
}

const getLegacyObj = (identifier) => {
    return {
        timeslots: days.value.find(d => d.identifier === identifier).slots.map(d => {
            return {
                time_start: d.start,
                time_end: d.end,
                interval: d.interval,
                pause: d.pause,
                blocking: d.type !== 'work',
                exclude_workers: []
            }
        }),
        id: identifier,
        label: days.value.find(d => d.identifier === identifier).day,
        selected: days.value.find(d => d.identifier === identifier).slots.length > 0
    }
}

const loadFromLegacyObj = (legacyObj) => {
    return {
        day: legacyObj.label,
        identifier: legacyObj.id,
        slots: legacyObj.timeslots.filter(el => el.time_start && el.time_end).map(d => {
            return {
                start: d.time_start,
                end: d.time_end,
                interval: d.interval,
                pause: d.pause,
                type: d.blocking ? 'standard' : 'work'
            }
        })
    }
}

let skipModelWatcher = false;
let skipDaysWatcher = false;

watch(() => model.value, (now) => {
    if (skipModelWatcher) {
        skipModelWatcher = false;
        return;
    }
    if (now && now?.days) {
        skipDaysWatcher = true;
        days.value = [
            loadFromLegacyObj(now.days.mon),
            loadFromLegacyObj(now.days.tue),
            loadFromLegacyObj(now.days.wed),
            loadFromLegacyObj(now.days.thu),
            loadFromLegacyObj(now.days.fri),
            loadFromLegacyObj(now.days.sat),
            loadFromLegacyObj(now.days.sun),
        ];
    }
}, { immediate: true, deep: true });

watch(() => days.value, () => {
    if (skipDaysWatcher) {
        skipDaysWatcher = false;
        return;
    }
    skipModelWatcher = true;
    if (model.value?.days) {

        model.value.days = {
            mon: getLegacyObj('mon'),
            tue: getLegacyObj('tue'),
            wed: getLegacyObj('wed'),
            thu: getLegacyObj('thu'),
            fri: getLegacyObj('fri'),
            sat: getLegacyObj('sat'),
            sun: getLegacyObj('sun'),
        };
    }
}, { deep: true });
</script>

<template>
    <div class="flex  pl-4 dark:bg-neutral-900 dark:border-neutral-700 bg-neutral-100 shadow-sm" :key="slotHeight">
        <div class="flex flex-col text-center border-r dark:border-neutral-700 pr-4 ">
            <div class="h-10"></div>
            <div v-for="time in times.filter(el => el % 1 === 0)" :style="{ height: `${slotHeight}px` }" class="text-sm opacity-60">{{numberToTime(time)}}</div>
        </div>
        <day-part :day="computedDay.day" v-model:active-event="activeEvent" v-model="computedDay.slots" v-model:form="form" :slot-height="slotHeight" :min-time="minTime" :max-time="maxTime" :increment="increment">
            <template #pre>
                <Button icon="pi pi-arrow-left" size="small" rounded text @click="prevDay"></Button>
            </template>
            <template #post>
                <Button icon="pi pi-arrow-right" size="small" rounded text @click="nextDay"></Button>
            </template>
        </day-part>
    </div>
</template>

<style scoped lang="scss">

</style>
